export default "__VITE_PUBLIC_ASSET__33b1c39b__"